import type { StandardScreen } from '@mfw/common';

import { findStandardScreen } from '@mfw/common';
import React, { useState } from 'react';
export default function useTenantSplashScreen({
  splashScreens,
}: {
  splashScreens: { name: string; url: string }[] | undefined;
}) {
  const [splashUrl, setSplashUrl] = useState<null | string | undefined>();
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const devicePixelRatio = window.devicePixelRatio;

  React.useEffect(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    if (splashScreens) {
      const deviceName: StandardScreen = findStandardScreen(width, height);
      const image = splashScreens.find((scr) => scr.name === deviceName.name);
      setSplashUrl(image?.url);
    } else setSplashUrl(null);
  }, [splashScreens]);

  return {
    devicePixelRatio,
    screenHeight,
    screenWidth,
    splashUrl,
  };
}
